var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{on:{"click":function($event){return _vm.operate('edit', _vm.rowData)}}},[_vm._v("编辑")]),_c('span',{on:{"click":function($event){return _vm.operate('del', _vm.rowData)}}},[_vm._v("删除")])])}
var staticRenderFns = []

export { render, staticRenderFns }